import { render, staticRenderFns } from "./SectionBottom.vue?vue&type=template&id=82812932&scoped=true&lang=pug"
import script from "./SectionBottom.vue?vue&type=script&lang=js"
export * from "./SectionBottom.vue?vue&type=script&lang=js"
import style0 from "./SectionBottom.vue?vue&type=style&index=0&id=82812932&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82812932",
  null
  
)

export default component.exports